
import React, { useEffect, useState } from "react";
import MasterLayout from "../Sections/MasterLayout";
import Loader from "./Loader";
import { useNavigate, Link } from "react-router-dom";
import {
  get_all_orders,
  server_post_json,
} from "../../ServiceConnection/serviceconnection.js";

export default function Orders() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const fetchOrders = async () => {
    try {
      setLoading(true);
      const res = await server_post_json(get_all_orders);
      setOrders(res.data.orders || []);
    } catch (err) {
      console.error("Fetch orders failed", err);
      setOrders([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  const badge = (text) => {
    const t = text?.toLowerCase();
    const map = {
      pending: "bg-yellow-100 text-yellow-800",
      paid: "bg-green-100 text-green-700",
      shipped: "bg-blue-100 text-blue-700",
      delivered: "bg-green-100 text-green-700",
      cancelled: "bg-red-100 text-red-700",
      sent_to_qikink: "bg-purple-100 text-purple-700",
    };
    return (
      <span
        className={`px-2 py-0.5 rounded-full text-xs ${
          map[t] || "bg-gray-100"
        }`}
      >
        {text}
      </span>
    );
  };

  return (
    <MasterLayout>
      {loading && <Loader />}

      <div className="p-4">



   {/* HEADER */}
   <div className="flex items-center justify-between mb-5">
          <h2 className="text-lg sm:text-2xl font-bold text-gray-800">
          Orders ({orders.length})
          </h2>

          <button
            onClick={() => navigate("/create-order")}
            className="px-6 py-2.5 bg-[var(--primary-color)] text-white rounded-lg hover:bg-[var(--primary-hover)] text-sm font-medium"
          >
          Create Order
          </button>
        </div>
        <div className="bg-white border rounded-xl overflow-x-auto">
          <table className="min-w-[900px] w-full text-sm">
            <thead className="bg-gray-50 border-b">
              <tr>
                {[
                  "Order",
                  "Date",
                  "Customer",
                  "Total",
                  "Payment",
                  "Status",
                  "Action",
                ].map((h) => (
                  <th
                    key={h}
                    className="px-4 py-3 text-left text-xs font-semibold text-gray-600"
                  >
                    {h}
                  </th>
                ))}
              </tr>
            </thead>

            <tbody className="divide-y">
              {orders.length ? (
                orders.map((o) => (
                  <tr key={o._id} className="hover:bg-gray-50">
                    <td className="px-4 py-3 font-medium">#{o.order_id}</td>
                    <td className="px-4 py-3 text-gray-500">
                      {new Date(o.createdAt).toLocaleString("en-IN")}
                    </td>
                    <td className="px-4 py-3">
                      {o.shippingAddress?.name || "N/A"}
                    </td>
                    <td className="px-4 py-3 font-medium">₹{o.totalAmount}</td>
                    <td className="px-4 py-3">{badge(o.paymentStatus)}</td>
                    <td className="px-4 py-3">{badge(o.orderStatus)}</td>
                    <td className="px-4 py-3">
                      <button
                        onClick={() =>
                          navigate(`/orders/${o.order_id}`, {
                            state: { order: o },
                          })
                        }
                        className="text-blue-600 text-sm hover:underline"
                      >
                        View Order→
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="py-10 text-center text-gray-500">
                    No orders found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </MasterLayout>
  );
}
